import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./StabilizationTower.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import StabilizerLaboratory from "./StabilizerLaboratory";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function StabilizationTower() {

    useEffect(() => {
    
      trackPageVisit("StabilizationTower");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const {processData,  setProcessData} = useContext(ProcessContext);
const [showLaboratory, setShowLaboratory] = useState(false);

     

  const DEFAULT_VALVES = {
  FCV_2801: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2802: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2803: { mode: "Manual", opening: 0, sp: "", pv: "" },


};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("StabilizationTower_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2801: { ...DEFAULT_VALVES.FCV_2801, ...parsed.FCV_2801 },
      FCV_2802: { ...DEFAULT_VALVES.FCV_2802, ...parsed.FCV_2802 },
      FCV_2803: { ...DEFAULT_VALVES.FCV_2803, ...parsed.FCV_2803 },


    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("StabilizationTower_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
            const { transmitters,  flowOverrides} = usePlantStore();
            const TT_2708 = transmitters.TT_2708 || 0;
            const FIC_2707 = transmitters.FIC_2707 || 0;
            const PT_2707 = transmitters.PT_2707 || 0;
            const TT_27010 = transmitters.TT_27010 || 0;
            const PT_22011 = transmitters.PT_22011 || 0;
            const TT_22011 = transmitters.TT_22011 || 0;
            const FIC_22011 = transmitters.FIC_22011 || 0;
            const FIC_29010 = transmitters.FIC_29010 || 0;
            const TT_29010 = transmitters.TT_29010 || 0;





  const xv2801Open = !valves?.XV_2801;
  const xv2802Open = !valves?.XV_2802;
  const xv2803Open = !valves?.XV_2803;
  const xv2804Open = !valves?.XV_2804;
  const xv2805Open = !valves?.XV_2805;
  const xv2806Open = !valves?.XV_2806;
  const xv2807Open = !valves?.XV_2807;
  const xv2808Open = !valves?.XV_2808;




  const FIC_2801 = FIC_2707;
  const PT_2801 =  PT_2707;
  const TT_2801 = TT_2708;

  const TT_28015 = TT_27010;

  const FIC_28014 = xv2802Open ? 0.1829 : 0;    // ================= CORROSION INHIBITOR INJECTION 
  const TT_28016 = xv2803Open ? 27.564 : 22;    // ================= FRESH WATER SUPPLY TO E-304
  
  const TT_28017 = TT_29010;
  const FIC_28017 = FIC_29010;

  const FIC_28018 = xv2806Open ? FIC_22011 : 0;
  const TT_28018 = xv2806Open ? TT_22011 : 32;
  const PT_28018 = xv2806Open ? PT_22011 : 0.03;
  

  const FeedComposition = {

  Methane: 0.005,        // C1

  Ethane: 0.015,         // C2

  Propane: 0.045,        // C3

  iButane: 0.060,

  nButane: 0.070,

  H2S: 0.002,

  CO2: 0.001,

  Hydrogen: 0.002,

  PentanesPlus: 0.790,

  Water: 0.005

};

  const FeedFlow = {

  Methane:
    FIC_2801 * FeedComposition.Methane,

  Ethane:
    FIC_2801 * FeedComposition.Ethane,

  Propane:
    FIC_2801 * FeedComposition.Propane,

  iButane:
    FIC_2801 * FeedComposition.iButane,

  nButane:
    FIC_2801 * FeedComposition.nButane,

  H2S:
    FIC_2801 * FeedComposition.H2S,

  CO2:
    FIC_2801 * FeedComposition.CO2,

  Hydrogen:
    FIC_2801 * FeedComposition.Hydrogen,

  PentanesPlus:
    FIC_2801 * FeedComposition.PentanesPlus,

  Water:
    FIC_2801 * FeedComposition.Water

};


const TotalFeed =

Object.values(FeedFlow).reduce(

(sum, value) => sum + value,

0

);


localStorage.setItem(

"StabilizerFeedComposition",

JSON.stringify(FeedComposition)

);

localStorage.setItem(

"StabilizerFeedFlow",

JSON.stringify(FeedFlow)

);

console.log(

"STABILIZER FEED",

{

Flow: FIC_2801,

Temperature: TT_2801,

Pressure: PT_2801,

Composition: FeedComposition,

ComponentFlows: FeedFlow,

TotalFeed

}

);








/* =========================================================
   TEMPERATURE FACTOR
========================================================= */

let TemperatureFactor = 0;

if (TT_2801 < 90)
{
  TemperatureFactor = 0.20;
}
else if (TT_2801 < 105)
{
  TemperatureFactor = 0.40;
}
else if (TT_2801 < 115)
{
  TemperatureFactor = 0.60;
}
else if (TT_2801 < 125)
{
  TemperatureFactor = 0.82;
}
else
{
  TemperatureFactor = 1.00;
}


/* =========================================================
   PRESSURE FACTOR
========================================================= */

const PressureFactor =

Math.max(

0.60,

1 -

((PT_2801 - 1.0) * 0.20)

);



/* =========================================================
   FLASH SEVERITY
========================================================= */

const FlashSeverity =

TemperatureFactor *

PressureFactor;


const FlashFactor = {

Methane: 1.00,

Ethane: 1.00,

Propane: 0.93,

iButane: 0.92,

nButane: 0.88,

H2S: 0.87,

CO2: 0.95,

Hydrogen: 1.00,

PentanesPlus: 0.08,

Water: 0.15

};


const FlashVapor = {

Methane:
FeedFlow.Methane *
FlashSeverity *
FlashFactor.Methane,

Ethane:
FeedFlow.Ethane *
FlashSeverity *
FlashFactor.Ethane,

Propane:
FeedFlow.Propane *
FlashSeverity *
FlashFactor.Propane,

iButane:
FeedFlow.iButane *
FlashSeverity *
FlashFactor.iButane,

nButane:
FeedFlow.nButane *
FlashSeverity *
FlashFactor.nButane,

H2S:
FeedFlow.H2S *
FlashSeverity *
FlashFactor.H2S,

CO2:
FeedFlow.CO2 *
FlashSeverity *
FlashFactor.CO2,

Hydrogen:
FeedFlow.Hydrogen *
FlashSeverity *
FlashFactor.Hydrogen,

PentanesPlus:
FeedFlow.PentanesPlus *
FlashSeverity *
FlashFactor.PentanesPlus,

Water:
FeedFlow.Water *
FlashSeverity *
FlashFactor.Water

};


const FlashLiquid = {

Methane:
FeedFlow.Methane -
FlashVapor.Methane,

Ethane:
FeedFlow.Ethane -
FlashVapor.Ethane,

Propane:
FeedFlow.Propane -
FlashVapor.Propane,

iButane:
FeedFlow.iButane -
FlashVapor.iButane,

nButane:
FeedFlow.nButane -
FlashVapor.nButane,

H2S:
FeedFlow.H2S -
FlashVapor.H2S,

CO2:
FeedFlow.CO2 -
FlashVapor.CO2,

Hydrogen:
FeedFlow.Hydrogen -
FlashVapor.Hydrogen,

PentanesPlus:
FeedFlow.PentanesPlus -
FlashVapor.PentanesPlus,

Water:
FeedFlow.Water -
FlashVapor.Water

};


const VaporFlow =

Object.values(FlashVapor).reduce(

(a,b)=>a+b,

0

);


const LiquidFlow =

Object.values(FlashLiquid).reduce(

(a,b)=>a+b,

0

);


localStorage.setItem(
"StabilizerFlashVapor",
JSON.stringify(FlashVapor)
);

localStorage.setItem(
"StabilizerFlashLiquid",
JSON.stringify(FlashLiquid)
);

localStorage.setItem(
"StabilizerFlashSeverity",
FlashSeverity
);

localStorage.setItem(
"StabilizerVaporFlow",
VaporFlow
);

localStorage.setItem(
"StabilizerLiquidFlow",
LiquidFlow
);


/* =========================================================
   LPG REFLUX EFFECT
========================================================= */

const RefluxRatio =

FIC_2801 > 0

?

FIC_28017 /
FIC_2801

:

0;

/*
Cold reflux condenses
more LPG and reduces
upper tower temperature.
*/

const RefluxCooling =

RefluxRatio *

Math.max(

0,

(120 - TT_28017) / 100

);


/* =========================================================
   TOWER VAPOR LOAD
========================================================= */

const TowerVaporFlow =

VaporFlow *

(

1 -

(RefluxCooling * 0.20)

);




/* =========================================================
   KETTLE REBOILER DRAW
========================================================= */

/*
Typically about 20–40% of the tower bottoms
circulate continuously through the reboiler.
*/

const ReboilerCirculationRatio = 0.30;

const FIC_2805 =
LiquidFlow *
ReboilerCirculationRatio;


/* =========================================================
   REBOILER INLET CONDITIONS
========================================================= */

const TT_2805 = xv2805Open ?
TT_2801 *1.05 : 28;

const PT_2805 =  xv2805Open ?
PT_2801 * 1.08 : 0.03;



/* =========================================================
   HOT SIDE (MAIN FRACTIONATOR PUMP AROUND)
========================================================= */

/*
Hot oil from Main Fractionator.
This is the heating medium.
*/

const HotOilFlow = FIC_28018;

const HotOilInletTemp = TT_28018;

const HotOilPressure = PT_28018;


/* =========================================================
   HEAT EXCHANGER EFFECTIVENESS
========================================================= */

/*
Higher flow gives
better heat transfer.

Lower flow gives
poorer heat transfer.
*/

const FlowRatio =

Math.min(

1,

HotOilFlow /

Math.max(FIC_2805,0.1)

);

/*
Typical refinery kettle
effectiveness.
*/

const ExchangerEfficiency =

0.82 *
FlowRatio;


/* =========================================================
   HEAT TRANSFER
========================================================= */

const TemperatureDrivingForce =

Math.max(

0,

HotOilInletTemp -

TT_2805

);

const ActualHeatTransfer =

TemperatureDrivingForce *

ExchangerEfficiency;



/* =========================================================
   HOT OIL OUTLET
========================================================= */

/*
Pump-around normally loses
8–15°C depending on flow.
*/

const TT_28019 =

Math.max(

120,

HotOilInletTemp -

Math.min(

15,

ActualHeatTransfer *
0.25

)

);

const PT_28019 =

Math.max(

0.5,

HotOilPressure -

0.05

);


/* =========================================================
   REBOILER OUTLET
========================================================= */

const TT_2806 =

TT_2805 +

ActualHeatTransfer *
0.55;

const PT_2806 =

PT_2805 -

0.03;


/* =========================================================
   REBOILER DUTY
========================================================= */

const ReboilerDuty =

FIC_2805 *

(TT_2806 - TT_2805);


const StrippingFactor =

Math.min(

1,

ReboilerDuty /

20

);

/* =========================================================
   REBOILER RETURN VAPOR
========================================================= */

/*
The kettle generates stripping vapor
which returns to the tower bottom.
*/

const ReboilerVaporFlow =

FIC_2805 *

0.30 *

StrippingFactor;

/*
Total vapor travelling upward
inside the stabilizer.
*/


/* =========================================================
   REBOILER VAPOR COMPOSITION
========================================================= */

/*
Split the generated stripping vapor
into individual components.
*/

const ReboilerVapor = {

Methane:
FlashLiquid.Methane *
0.95 *
StrippingFactor,

Ethane:
FlashLiquid.Ethane *
0.95 *
StrippingFactor,

Propane:
FlashLiquid.Propane *
0.90 *
StrippingFactor,

iButane:
FlashLiquid.iButane *
0.82 *
StrippingFactor,

nButane:
FlashLiquid.nButane *
0.78 *
StrippingFactor,

H2S:
FlashLiquid.H2S *
0.92 *
StrippingFactor,

CO2:
FlashLiquid.CO2 *
0.90 *
StrippingFactor,

Hydrogen:
FlashLiquid.Hydrogen *
0.98 *
StrippingFactor,

PentanesPlus:
FlashLiquid.PentanesPlus *
0.03 *
StrippingFactor,

Water:
FlashLiquid.Water *
0.95 *
StrippingFactor

};




const InternalTowerVapor =

TowerVaporFlow +

ReboilerVaporFlow;




/* =========================================================
   TOP TEMPERATURE
========================================================= */

const TT_2802 =

Math.max(

35,

TT_2801 - 25 + InternalTowerVapor * 3.5 - (RefluxCooling * 18)

);


/* =========================================================
   TOP PRESSURE
========================================================= */

const PT_2802 =

PT_2801

-

0.03

+

InternalTowerVapor * 0.02;


/* =========================================================
   MIDDLE TEMPERATURE
========================================================= */

const TT_2803 =

TT_2801

-

10

+

InternalTowerVapor * 5

-

(RefluxCooling * 8);


/* =========================================================
   MIDDLE PRESSURE
========================================================= */

const PT_2803 =

PT_2802 +

InternalTowerVapor * 0.01;


/* =========================================================
   BOTTOM TEMPERATURE
========================================================= */

const TT_2804 =

TT_2801

+

6

+

ReboilerDuty * 0.18

-

ReboilerVaporFlow * 0.8;


/* =========================================================
   BOTTOM PRESSURE
========================================================= */

const PT_2804 =

PT_2803 +

0.02 +

ReboilerVaporFlow * 0.01;




/* =========================================================
   EFFECTIVE STRIPPING
========================================================= */

/*
Both reflux and the reboiler determine
how well the stabilizer separates LPG
from stabilized naphtha.
*/

const SeparationEfficiency =

Math.min(

1,

0.55 +

(StrippingFactor * 0.30) +

(RefluxCooling * 0.15)

);

console.log(
"Separation Efficiency",
SeparationEfficiency
);


/* =========================================================
   OVERHEAD LPG PRODUCT
========================================================= */

const OverheadProduct = {

Methane:

FlashVapor.Methane +

(ReboilerVapor.Methane || 0),

Ethane:

FlashVapor.Ethane +

(ReboilerVapor.Ethane || 0),

Propane:

(FlashVapor.Propane +
(ReboilerVapor.Propane || 0))
*
SeparationEfficiency,

iButane:

(FlashVapor.iButane +
(ReboilerVapor.iButane || 0))
*
SeparationEfficiency,

nButane:

(FlashVapor.nButane +
(ReboilerVapor.nButane || 0))
*
SeparationEfficiency,

H2S:

(FlashVapor.H2S +
(ReboilerVapor.H2S || 0))
*
0.98,

CO2:

(FlashVapor.CO2 +
(ReboilerVapor.CO2 || 0))
*
0.98,

Hydrogen:

FlashVapor.Hydrogen +
(ReboilerVapor.Hydrogen || 0),

PentanesPlus:

(FlashVapor.PentanesPlus +
(ReboilerVapor.PentanesPlus || 0))
*
(1 - SeparationEfficiency) *
0.15,

Water:

(FlashVapor.Water +
(ReboilerVapor.Water || 0)) * 0.95

};


/* =========================================================
   STABILIZED NAPHTHA
========================================================= */

const BottomProduct = {

Methane:
FeedFlow.Methane -
OverheadProduct.Methane,

Ethane:
FeedFlow.Ethane -
OverheadProduct.Ethane,

Propane:
FeedFlow.Propane -
OverheadProduct.Propane,

iButane:
FeedFlow.iButane -
OverheadProduct.iButane,

nButane:
FeedFlow.nButane -
OverheadProduct.nButane,

H2S:
FeedFlow.H2S -
OverheadProduct.H2S,

CO2:
FeedFlow.CO2 -
OverheadProduct.CO2,

Hydrogen:
FeedFlow.Hydrogen -
OverheadProduct.Hydrogen,

PentanesPlus:
FeedFlow.PentanesPlus -
OverheadProduct.PentanesPlus,

Water:
FeedFlow.Water -
OverheadProduct.Water

};


/* =========================================================
   PRODUCT FLOWS
========================================================= */

const FIC_2802 =

Object.values(OverheadProduct)
.reduce((a,b)=>a+b,0);

const FIC_2804 =

Object.values(BottomProduct)
.reduce((a,b)=>a+b,0);




/* =========================================================
   SAVE STABILIZER OVERHEAD STREAM
========================================================= */

localStorage.setItem(

  "STAB_OVERHEAD",

  JSON.stringify({

    Flow: FIC_2802,

    Temperature: TT_2802,

    Pressure: PT_2802,

    Composition: {

      Methane: OverheadProduct.Methane,

      Ethane: OverheadProduct.Ethane,

      Propane: OverheadProduct.Propane,

      iButane: OverheadProduct.iButane,

      nButane: OverheadProduct.nButane,

      H2S: OverheadProduct.H2S,

      CO2: OverheadProduct.CO2,

      Hydrogen: OverheadProduct.Hydrogen,

      PentanesPlus: OverheadProduct.PentanesPlus,

      Water: OverheadProduct.Water

    }

  })

);








  /* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};


/* =========================================================
   P-303A / B STATUS
========================================================= */

const P303A_Running =
  pumpData?.["P-303A"]?.running ?? false;

const P303B_Running =
  pumpData?.["P-303B"]?.running ?? false;

const P303_Running =
  P303A_Running || P303B_Running;


/* =========================================================
   SUCTION VALVE
========================================================= */

const suctionAvailable =
  xv2804Open === true;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P303_CAPACITY = 4;


/* =========================================================
   CONTROL VALVE
========================================================= */

const FCV2801_Opening =
  valveData?.FCV_2801?.opening / 100 || 0;


/* =========================================================
   TARGET FLOW
========================================================= */

const targetFIC_28020 =
(
  P303_Running &&
  suctionAvailable
)
?
P303_CAPACITY *
FCV2801_Opening
:
0;


/* =========================================================
   DISCHARGE FLOW
========================================================= */

const FIC_28020 = flowOverrides?.FIC_28020 ? 0 : (processData.FIC_28020 || 0);

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_28020_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_28020 || 0);

    let next = current;

    const systemActive =
      P303A_Running ||
      P303B_Running;

    const target =
      systemActive
        ? targetFIC_28020
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    for (
      let i = 0;
      i < scans;
      i++
    ) {

      next =
        next +
        (
          target -
          next
        ) * 0.12;

    }

    return {
      ...prev,
      FIC_28020: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFIC_28020,
  P303A_Running,
  P303B_Running
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_28020_LastUpdate",
    String(Date.now())
  );

}, [FIC_28020]);




useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_28020 || 0);

      const target =
        Number(targetFIC_28020 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_28020: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_28020]);



/* =========================================================
   DISCHARGE PRESSURE
========================================================= */

const [PT_28020,setPT_28020]=
useState(0.03);

useEffect(()=>{

const timer=setInterval(()=>{

let targetPressure=0.03;

if(
P303_Running &&
suctionAvailable
){

if(FCV2801_Opening<=0){

// Dead head
targetPressure=2.20;

}
else if(FCV2801_Opening<0.20){

// High restriction
const restriction=
(0.20-FCV2801_Opening)/0.20;

targetPressure=
1.20+
restriction*
1.00;

}
else{

// Normal operation
targetPressure=
1.20-
(
FCV2801_Opening-
0.20
)
*
0.20;

}

}

setPT_28020(prev=>
Number(
(
prev+
(targetPressure-prev)*
0.08
).toFixed(3)
));

},500);

return()=>clearInterval(timer);

},
[
P303_Running,
suctionAvailable,
FCV2801_Opening
]);


/* =========================================================
   DISCHARGE TEMPERATURE
========================================================= */

const [TT_28020,setTT_28020]=
useState(TT_2804);

useEffect(()=>{

const timer=setInterval(()=>{

let targetTemp= P303_Running ?
Number(TT_2804) : 32;

if(
P303_Running &&
suctionAvailable
){

// Small heating through pump

targetTemp=
Number(TT_2804)+0.5;

if(
FCV2801_Opening<0.20
){

const restriction=
(0.20-FCV2801_Opening)/0.20;

targetTemp=
Number(TT_2804)+
0.5+
restriction*4;

}

}

setTT_28020(prev=>
Number(
(
prev+
(targetTemp-prev)*
0.08
).toFixed(2)
));

},500);

return()=>clearInterval(timer);

},
[
TT_2804,
P303_Running,
suctionAvailable,
FCV2801_Opening
]);






/* =========================================================
   E-303A/B
   STABILIZED NAPHTHA / COOLING WATER COOLER
========================================================= */

const TT_28021 =
  processData.TT_28021;

const TT_28022 =
  processData.TT_28022;

const AtmosphericTemperature = 25;


/* =========================================================
   REFS
========================================================= */

const E303_intervalRef =
  useRef(null);

const E303_isMounted =
  useRef(false);

const E303_processRef =
  useRef({});


/* =========================================================
   KEEP VALUES UPDATED
========================================================= */

useEffect(() => {

  E303_processRef.current = {

    TT_28015,
    TT_28016,
    xv2803Open

  };

});


/* =========================================================
   E-303 COOLER
========================================================= */

useEffect(() => {

  if (E303_isMounted.current) return;

  E303_isMounted.current = true;

  console.log(
    "✅ E-303 interval created"
  );

  E303_intervalRef.current =
    setInterval(() => {

      const {

        TT_28015,
        TT_28016,
        xv2803Open

      } = E303_processRef.current;


      /* =====================================
         FLOW CONDITIONS
      ===================================== */

      const waterFlow =
        xv2803Open;


      const stream1 =
        Number(TT_28015) || 0;

      const stream2 =
        waterFlow
          ? Number(TT_28016) || AtmosphericTemperature
          : AtmosphericTemperature;


      let targetTT28022 =
        stream1;

      let targetTT28021 =
        stream2;


      /* =====================================
         DETERMINE HOT/COLD STREAM
      ===================================== */

      const hotter =
        Math.max(stream1, stream2);

      const colder =
        Math.min(stream1, stream2);

      const deltaT =
        hotter - colder;


      /* =====================================
         HEAT EXCHANGE
      ===================================== */

      if (
        waterFlow &&
        deltaT > 0.05
      ) {

        /*
          Cooler effectiveness
        */

        const effectiveness =
          0.25;

        const duty =
          Math.max(
            0.20,
            deltaT * effectiveness
          );

        const secondaryDuty =
          duty * 0.70;

        if (stream1 >= stream2) {

          // Naphtha hotter

          targetTT28022 =
            stream1 - duty;

          targetTT28021 =
            stream2 + secondaryDuty;

        }

        else {

          // Water hotter

          targetTT28022 =
            stream1 + secondaryDuty;

          targetTT28021 =
            stream2 - duty;

        }

      }


      /* =====================================
         PHYSICAL LIMITS
      ===================================== */

      if (stream1 >= stream2) {

        targetTT28022 =
          Math.max(
            targetTT28022,
            stream2 + 1
          );

        targetTT28021 =
          Math.min(
            targetTT28021,
            stream1 - 1
          );

      }

      else {

        targetTT28021 =
          Math.max(
            targetTT28021,
            stream1 + 1
          );

        targetTT28022 =
          Math.min(
            targetTT28022,
            stream2 - 1
          );

      }


      /* =====================================
         THERMAL LAG
      ===================================== */

      setProcessData(prev => ({

        ...prev,

        TT_28021: Number(

          (

            (prev.TT_28021 ?? stream2)

            +

            (

              targetTT28021 -

              (prev.TT_28021 ?? stream2)

            ) * 0.08

          ).toFixed(2)

        ),

        TT_28022: Number(

          (

            (prev.TT_28022 ?? stream1)

            +

            (

              targetTT28022 -

              (prev.TT_28022 ?? stream1)

            ) * 0.08

          ).toFixed(2)

        )

      }));

    }, 1000);

  return () => {

    console.log(
      "❌ E-303 interval cleared"
    );

    if (E303_intervalRef.current) {

      clearInterval(
        E303_intervalRef.current
      );

      E303_intervalRef.current =
        null;

    }

    E303_isMounted.current =
      false;

  };

}, []);





const FIC_28022 = FIC_28020 * 0.995;
const PT_28022 = PT_28020 * 0.687;



/* =========================================================
              SPLITTING MAIN NAPHTHA LINE
========================================================= */

const openNaphthaBranchCount =
[
  xv2807Open,
  xv2808Open
].filter(Boolean).length;

const FIC_28023 =
  xv2808Open
    ? FIC_28022 / openNaphthaBranchCount
    : 0;

const FIC_28024 =
  xv2807Open
    ? FIC_28022 / openNaphthaBranchCount
    : 0;

const TT_28023 = xv2808Open ? TT_28022 : 25;
const PT_28023 = xv2808Open ? PT_28022 : 0.03;
const TT_28024 = xv2807Open ? TT_28022 : 25;
const PT_28024 = xv2807Open ? PT_28022 : 0.03;



  const FIC_28013 = FIC_2802 * 0.834 * (valveData?.FCV_2803?.opening || 0)/100;    
  const TT_28013 = (valveData?.FCV_2803?.opening || 0)/100 > 0 ? TT_2802 : 25;    
  const PT_28013 = (valveData?.FCV_2803?.opening || 0)/100 > 0 ? PT_2802 : 0.03;    






useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_28020 === FIC_28020 &&
    current.TT_28020 === TT_28020 &&
    current.PT_28020 === PT_28020 && 
    current.PT_28023 === PT_28023 &&
    current.FIC_28023 === FIC_28023 &&
    current.PT_28024 === PT_28024 &&
    current.TT_28023 === TT_28023 &&
    current.FIC_28024 === FIC_28024 &&
    current.TT_28024 === TT_28024 &&
    current.TT_28013 === TT_28013 &&
    current.PT_28013 === PT_28013 &&
    current.FIC_2802 === FIC_2802 &&
    current.TT_2802 === TT_2802 &&
    current.PT_2802 === PT_2802
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_28020, TT_28020, PT_28020, FIC_28023, PT_28023, TT_28023, PT_28024, FIC_28024, TT_28024, PT_28013, TT_28013, FIC_28013, FIC_2802, TT_2802, PT_2802,
    }
  });

}, [FIC_28020, TT_28020, PT_28020, FIC_28023, PT_28023, TT_28023, PT_28024, FIC_28024, TT_28024, PT_28013, TT_28013, FIC_28013, FIC_2802, TT_2802, PT_2802,]);






/* ==========================================================
   STABILIZER TOWER REPORT
========================================================== */

const StabilizerReport = {

    reportInfo: {

        reportTitle:
            "STABILIZER TOWER PERFORMANCE REPORT",

        generatedOn:
            new Date().toLocaleString(),

        generatedDate:
            new Date().toLocaleDateString(),

        generatedTime:
            new Date().toLocaleTimeString()

    },



    /* ======================================================
       FEED
    ====================================================== */

    feed: {

        flow: FIC_2801,

        temperature: TT_2801,

        pressure: PT_2801,

        totalFeed: TotalFeed,

        composition: FeedComposition,

        componentFlow: FeedFlow

    },



    /* ======================================================
       FLASH ZONE
    ====================================================== */

    flashZone: {

        temperatureFactor:
            TemperatureFactor,

        pressureFactor:
            PressureFactor,

        flashSeverity:
            FlashSeverity,

        vaporFlow:
            VaporFlow,

        liquidFlow:
            LiquidFlow,

        vaporComposition:
            FlashVapor,

        liquidComposition:
            FlashLiquid

    },



    /* ======================================================
       TOWER
    ====================================================== */

    tower: {

        top: {

            temperature: TT_2802,

            pressure: PT_2802

        },

        middle: {

            temperature: TT_2803,

            pressure: PT_2803

        },

        bottom: {

            temperature: TT_2804,

            pressure: PT_2804

        },

        internalVapor:

            InternalTowerVapor,

        refluxRatio:

            RefluxRatio,

        refluxCooling:

            RefluxCooling,

        separationEfficiency:

            SeparationEfficiency

    },



    /* ======================================================
       REBOILER
    ====================================================== */

    reboiler: {

        circulationFlow:

            FIC_2805,

        inletTemperature:

            TT_2805,

        outletTemperature:

            TT_2806,

        inletPressure:

            PT_2805,

        outletPressure:

            PT_2806,

        hotOilFlow:

            HotOilFlow,

        hotOilInletTemperature:

            HotOilInletTemp,

        hotOilPressure:

            HotOilPressure,

        hotOilOutletTemperature:

            TT_28019,

        hotOilOutletPressure:

            PT_28019,

        heatTransfer:

            ActualHeatTransfer,

        duty:

            ReboilerDuty,

        strippingFactor:

            StrippingFactor,

        vaporFlow:

            ReboilerVaporFlow,

        vaporComposition:

            ReboilerVapor

    },



    /* ======================================================
       OVERHEAD LPG
    ====================================================== */

    overhead: {

        flow:

            FIC_2802,

        temperature:

            TT_2802,

        pressure:

            PT_2802,

        composition:

            OverheadProduct

    },



    /* ======================================================
       STABILIZED NAPHTHA
    ====================================================== */

    bottoms: {

        flow:

            FIC_2804,

        temperature:

            TT_2804,

        pressure:

            PT_2804,

        composition:

            BottomProduct

    },



    /* ======================================================
       PUMP
    ====================================================== */

    pump: {

        running:

            P303_Running,

        flow:

            FIC_28020,

        temperature:

            TT_28020,

        pressure:

            PT_28020

    },



    /* ======================================================
       COOLER
    ====================================================== */

    cooler: {

        hotInlet:

            TT_28015,

        coldInlet:

            TT_28016,

        hotOutlet:

            TT_28022,

        coldOutlet:

            TT_28021,

        outletFlow:

            FIC_28022,

        outletPressure:

            PT_28022

    },



    /* ======================================================
       PERFORMANCE
    ====================================================== */

    performance: {

        flashSeverity:

            FlashSeverity,

        separationEfficiency:

            SeparationEfficiency,

        reboilerDuty:

            ReboilerDuty,

        heatTransfer:

            ActualHeatTransfer,

        internalTowerVapor:

            InternalTowerVapor,

        refluxCooling:

            RefluxCooling,

        refluxRatio:

            RefluxRatio

    }

};



localStorage.setItem(

    "STABILIZER_REPORT",

    JSON.stringify(StabilizerReport)

);






  return (
    <div className="StabilizationTower-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "5px",
          left: "220px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 306px",
          zIndex: 10,
        }}
      >
        STABILIZER TOWER
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}


      {/* XV-2802 */}
      <Valve
        className="XV-2802"
        tag="XV_2802"
        x={321}
        y={120}
        isClosed={valves.XV_2802}
        toggle={toggleValve}
      />

      {/* XV-2803 */}
      <Valve
        className="XV-2803"
        tag="XV_2803"
        x={181}
        y={674}
        isClosed={valves.XV_2803}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-2804 */}
      <Valve
        className="XV-2804"
        tag="XV_2804"
        x={471}
        y={624}
        isClosed={valves.XV_2803}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-2805 */}
      <Valve
        className="XV-2805"
        tag="XV_2805"
        x={691}
        y={548}
        isClosed={valves.XV_2805}
        toggle={toggleValve}
      />

      {/* XV-2806 */}
      <Valve
        className="XV-2806"
        tag="XV_2806"
        x={1101}
        y={321}
        isClosed={valves.XV_2806}
        toggle={toggleValve}
      />

      {/* XV-2807 */}
      <Valve
        className="XV-2807"
        tag="XV_2807"
        x={1001}
        y={790}
        isClosed={valves.XV_2807}
        toggle={toggleValve}
      />

      {/* XV-2808 */}
      <Valve
        className="XV-2808"
        tag="XV_2808"
        x={1001}
        y={885}
        isClosed={valves.XV_2808}
        toggle={toggleValve}
      />




      <button
          onClick={() => setShowLaboratory(true)}
          style={{
              position: "absolute",
              right: "350px",
              top: "250px",
              padding: "8px 16px",
              background: "#0b5ed7",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
              zIndex: 500
          }}
      >
          📑 Stabilizer Tower Report
      </button>


      {
          showLaboratory && (
              <StabilizerLaboratory
                  onClose={() =>
                      setShowLaboratory(false)
                  }
              />
          )
      }


      



      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2801 */}
        <div
            style={{ position: "absolute", left: 900, top: 636}}
            onMouseEnter={() => setHoveredValve("FCV_2801")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2801")}
          >

            {hoveredValve === "FCV_2801" && (
              <div style={tagStyle}>
                FCV_2801
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2801">
                    
          <defs>
            <linearGradient id="metal_2801">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2801)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2801)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

       

         {/* FCV-2803 */}
        <div
            style={{ position: "absolute", left: 160, top: 70}}
            onMouseEnter={() => setHoveredValve("FCV_2803")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2803")}
          >

            {hoveredValve === "FCV_2803" && (
              <div style={tagStyle}>
                FCV_2803
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2803">
                    
          <defs>
            <linearGradient id="metal_2803">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2803)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2803)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>



        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 280 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 280 + index * 40
              }}
            />
          ))}




      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_2801?.opening || 0)}
        x={922}
        y={688}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2803?.opening || 0)}
        x={182}
        y={115}
      />






      <Transmitter
        tag="FIC_2801"
        value={[FIC_2801]}
        x={135}
        y={177}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA FROM V-301 THROUGH E-301A/B TO INLET OF STABILIZER TOWER (T-301)"
      />


      <Transmitter
        tag="PT_2801"
        value={[PT_2801]}
        x={235}
        y={177}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF NAPHTHA FROM V-301 THROUGH E-301A/B TO INLET OF STABILIZER TOWER (T-301)"
      />


      <Transmitter
        tag="TT_2801"
        value={[TT_2801]}
        x={345}
        y={177}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF NAPHTHA FROM V-301 THROUGH E-301A/B TO INLET OF STABILIZER TOWER (T-301)"
      />

      <Transmitter
        tag="PT_2802"
        value={[PT_2802]}
        x={735}
        y={85}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF STABILIZER TOWER (T-301) OVERHEAD VAPOR TO CONDENSER SYSTEM"
      />


      <Transmitter
        tag="TT_2802"
        value={[TT_2802]}
        x={845}
        y={85}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF STABILIZER TOWER (T-301) OVERHEAD VAPOR TO CONDENSER SYSTEM"
      />

      <Transmitter
        tag="FIC_2802"
        value={[FIC_2802]}
        x={995}
        y={85}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF STABILIZER TOWER (T-301) OVERHEAD VAPOR TO CONDENSER SYSTEM"
      />

      <Transmitter
        tag="PT_2803"
        value={[PT_2803]}
        x={665}
        y={295}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF MIDDLE SECTION OF STABILIZER TOWER (T-301)"
      />


      <Transmitter
        tag="TT_2803"
        value={[TT_2803]}
        x={665}
        y={255}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF MIDDLE SECTION OF STABILIZER TOWER (T-301)"
      />

      <Transmitter
        tag="PT_2804"
        value={[PT_2804]}
        x={465}
        y={535}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF BOTTOM SECTION OF STABILIZER TOWER (T-301)"
      />


      <Transmitter
        tag="TT_2804"
        value={[TT_2804]}
        x={405}
        y={575}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF BOTTOM SECTION OF STABILIZER TOWER (T-301)"
      />

      <Transmitter
        tag="PT_2805"
        value={[PT_2805]}
        x={765}
        y={535}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF KETTLE REBOILER (E-303) DRAW FROM STABILIZER TOWER (T-301)"
      />


      <Transmitter
        tag="TT_2805"
        value={[TT_2805]}
        x={865}
        y={575}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF KETTLE REBOILER (E-303) DRAW FROM STABILIZER TOWER (T-301)"
      />

      <Transmitter
        tag="PT_2806"
        value={[PT_2806]}
        x={675}
        y={438}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF KETTLE REBOILER (E-303) DRAW FROM KETTLE REBOILER BACK TO STABILIZER TOWER (T-301) AFTER VAPORIZATION"
      />


      <Transmitter
        tag="TT_2806"
        value={[TT_2806]}
        x={805}
        y={345}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF KETTLE REBOILER (E-303) DRAW FROM KETTLE REBOILER BACK TO STABILIZER TOWER (T-301) AFTER VAPORIZATION"
      />

      <Transmitter
        tag="TT_28015"
        value={[TT_28015]}
        x={145}
        y={327}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF NAPHTHA FROM E-301A/B TO E-304A/B"
      />

      <Transmitter
        tag="FIC_28013"
        value={[FIC_28013]}
        x={335}
        y={68}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF STABILIZER OVERHEAD LINE TO V-303"
      />

      <Transmitter
        tag="TT_28013"
        value={[TT_28013]}
        x={435}
        y={68}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF STABILIZER OVERHEAD LINE TO V-303"
      />

      <Transmitter
        tag="FIC_28014"
        value={[FIC_28014]}
        x={435}
        y={112}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF AMINE INHIBITOR TO OVERHEAD LINE OF STABILIZER TOWER (T-301)"
      />

      <Transmitter
        tag="TT_28016"
        value={[TT_28016]}
        x={135}
        y={722}
        unit="°C"
        max={100}
        HH={70}
        H={60}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF FRESH WATER SUPPLY TO E-304A/B"
      />

      <Transmitter
        tag="TT_28017"
        value={[TT_28017]}
        x={725}
        y={162}
        unit="°C"
        max={100}
        HH={70}
        H={60}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF LPG FROM REFLUX DRUM TO OVERHEAD TOP SECTION OF STABILIZER TOWER (T_301)"
      />

      <Transmitter
        tag="FIC_28017"
        value={[FIC_28017]}
        x={985}
        y={162}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF LPG FROM REFLUX DRUM TO OVERHEAD TOP SECTION OF STABILIZER TOWER (T_301)"
      />

      <Transmitter
        tag="FIC_28018"
        value={[FIC_28018]}
        x={1005}
        y={307}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF PUMP AROUND DRAW FROM MAIN FRACTIONATION TOWER THROUGH P-107A/B TO STABILIZER TOWER KETTLE REBOILER (E-303)"
      />


      <Transmitter
        tag="PT_28018"
        value={[PT_28018]}
        x={1165}
        y={307}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF PUMP AROUND DRAW FROM MAIN FRACTIONATION TOWER THROUGH P-107A/B TO STABILIZER TOWER KETTLE REBOILER (E-303)"
      />


      <Transmitter
        tag="TT_28018"
        value={[TT_28018]}
        x={945}
        y={377}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF PUMP AROUND DRAW FROM MAIN FRACTIONATION TOWER THROUGH P-107A/B TO STABILIZER TOWER KETTLE REBOILER (E-303)"
      />


      <Transmitter
        tag="PT_28019"
        value={[PT_28019]}
        x={1155}
        y={437}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF PUMP AROUND DRAW FROM E-303 TO E-108 A-D"
      />


      <Transmitter
        tag="TT_28019"
        value={[TT_28019]}
        x={1055}
        y={528}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF PUMP AROUND DRAW FROM E-303 TO E-108 A-D"
      />

      <Transmitter
        tag="PT_28020"
        value={[PT_28020]}
        x={755}
        y={727}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF STABILIZED NAPHTHA FROM BOTTOM OF STABILIZATION TOWER (T-301) THROUGH P-303A/B TO E-301A/B"
      />


      <Transmitter
        tag="TT_28020"
        value={[TT_28020]}
        x={1125}
        y={628}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF STABILIZED NAPHTHA FROM BOTTOM OF STABILIZATION TOWER (T-301) THROUGH P-303A/B TO E-301A/B"
      />

      <Transmitter
        tag="FIC_28020"
        value={[FIC_28020]}
        x={1000}
        y={628}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF STABILIZED NAPHTHA FROM BOTTOM OF STABILIZATION TOWER (T-301) THROUGH P-303A/B TO E-301A/B"
      />

      <Transmitter
        tag="TT_28021"
        value={[TT_28021]}
        x={135}
        y={399}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF FRESH WATER RETURN FROM E-304A/B TO WATER HEADER"
      />


      <Transmitter
        tag="TT_28022"
        value={[TT_28022]}
        x={365}
        y={868}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF STABILIZED NAPHTHA FROM E-304A/B TO STABILIZED NAPHTHA STORAGE TANK"
      />

      <Transmitter
        tag="FIC_28022"
        value={[FIC_28022]}
        x={665}
        y={868}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF STABILIZED NAPHTHA FROM E-304A/B TO STABILIZED NAPHTHA STORAGE TANK"
      />

      <Transmitter
        tag="PT_28022"
        value={[PT_28022]}
        x={865}
        y={868}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF STABILIZED NAPHTHA FROM E-304A/B TO STABILIZED NAPHTHA STORAGE TANK"
      />

      <Transmitter
        tag="FIC_28023"
        value={[FIC_28023]}
        x={1125}
        y={868}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF STABILIZED NAPHTHA FROM E-304A/B TO STABILIZED NAPHTHA STORAGE TANK"
      />

      <Transmitter
        tag="FIC_28024"
        value={[FIC_28024]}
        x={1125}
        y={773}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF STABILIZED NAPHTHA FROM E-304A/B TO UNQUALIFIED LINE (SLOP TANK)"
      />






            <LevelTransmitterIndicator
              tag="LT_2801"
              totalLevel={500}
              inflows={[FIC_2804]}
              outflows={[FIC_28020]}
              inflowTags={["FIC_2804"]}
              outflowTags={["FIC_28020"]}
              responseFactor={0.05}
              columnX={564}
              columnY={420}
              columnWidth={84}
              columnHeight={121}
              textX={470}
              textY={400}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.5}
              service="lightnaphtha"
            />

            <Pump
              tag="P-303A"
              x={570}
              y={707}
              rpm={1800}
              bladeCount={pumpData?.["P-303A"]?.bladeCount || 3}
              size={pumpData?.["P-303A"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-303B"
              x={570}
              y={792}
              rpm={1800}
              bladeCount={pumpData?.["P-303B"]?.bladeCount || 3}
              size={pumpData?.["P-303B"]?.size || 45}
              onClick={openPumpPanel}
            />








    </div>
  );
}

export default StabilizationTower;